import { httpClient } from '../../config';
import { TUNE_GOAL_NAMES } from '../../config/constants/apiConstants';
import { PLATFORMS } from '../../config/constants/reportConstants';

const META_ALLOWED_GOALS = new Set(TUNE_GOAL_NAMES.map(goal => goal.name));

export const fetchConversionGoals = async ({ recordId, isCreate, apiUrl, platform, industryId }) => {
  try {
    const industryQuery = industryId ? `?industry_id=${industryId}` : '';
    const endpoint = recordId
      ? `${apiUrl}/tables/conversion_reports/report_goals/${recordId}`
      : `${apiUrl}/tables/conversion_reports/all_goals${industryQuery}`;

    const response = await httpClient(endpoint);
    if (!response?.json?.success) {
      throw new Error("Failed to fetch goals");
    }

    const { goals } = response.json;
    const filteredGoals = filterGoalsByPlatform({ goals, platform });
    return formatGoals({ goals: filteredGoals, isCreate });
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch processed goals.");
  }
};

export const formatGoals = ({ goals, isCreate }) => {
  const { selectedGoals, goalModifications } = extractGoalData(goals, isCreate);

  return {
    goalNames: extractGoalNames(goals),
    selectedGoals,
    goalModifications,
  };
};

export const filterGoalsByPlatform = ({ goals, platform }) => {
  if (platform === PLATFORMS.META) {
    return goals.filter(goal => META_ALLOWED_GOALS.has(goal.goal_name));
  }
  return goals;
};

const extractGoalNames = (goals) => goals.map(({ goal_name }) => goal_name);

const extractGoalData = (goals, isCreate) => {
  return goals.reduce((acc, { goal_name, is_selected, modified_name }) => {
    acc.selectedGoals[goal_name] = isCreate ? true : is_selected;
    acc.goalModifications[goal_name] = modified_name;
    return acc;
  },
  { selectedGoals: {}, goalModifications: {} });
};

export const updateFormState = ({ setValue, selectedGoals, goalModifications, goalNames }) => {
  const dataArray = goalNames.map((goal) => ({
    goal_name: goal,
    is_selected: selectedGoals[goal],
    modified_name: goalModifications[goal],
  }));

  setValue("conversions_goals", JSON.stringify(dataArray));
};
